import script from "./AppValidateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppValidateForm.vue?vue&type=script&lang=ts&setup=true"

import "./AppValidateForm.vue?vue&type=style&index=0&id=0e357d13&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e357d13"]])

export default __exports__